import React, { Component } from "react";
import { changeResetedPasswordRequest } from "./../components/auth/UserFunctions";
import { validateTokenRequest } from "./../components/auth/UserFunctions";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  FormInput,
  Button
} from "shards-react";
import { matchPath } from 'react-router'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

class ResetPassword extends Component{

  constructor(){
    super()
    this.state = {
      password:'',
      repeatPassword:'',
      error:''
    }

  }

  async componentDidMount(){
    const searchParams = new URLSearchParams(window.location.search);
    const match = matchPath(this.props.history.location.pathname, {
      path: '/change-password/:param',
      exact: true,
      strict: false
    })
    const token = match.params.param
    await this.validateToken(token)
    this.setState({token: token})

  }

  validateToken(token){
    validateTokenRequest(token).then(res => {
      if (res.response === 404){
        this.setState({message: 'El token expiró. Por favor generar uno nuevo', dialogOpen: true})
      } else {
        this.setState({email: res.data.email})
      }
    })
  }

  onChange = e => {
    this.setState({[e.target.id]: e.target.value})
  }

  handleValidations = () =>{
    if (this.state.password !== '' && this.state.repeatPassword!=='' && this.state.password !== this.state.repeatPassword){
      this.setState({error: 'Las contraseñas no coinciden.'})
      return false;
    } else {
      this.setState({error: ''})
      return true
    }

  }

  onSubmit = e => {
    e.preventDefault();
    if(this.handleValidations()){
      this.changePassword();
    } 
  }

  changePassword(){
      const request = {
        email: this.state.email,
        token: this.state.token,  
        password: this.state.password,
        repeatPassword: this.state.repeatPassword
      }
      changeResetedPasswordRequest(request).then(res => {
        if (res.status == 404){
          this.setState({message: 'El token expiró. Por favor generar uno nuevo', dialogOpen: true})
        } else {
          this.setState({message: 'Se ha cambiado la contraseña con éxito!',dialogOpen: true})
        }

      })
  }
  render (){

    return (
    <Container fluid className="main-content-container h-100 px-4">
      <Row noGutters className="h-100">
        <Col lg="3" md="5" className="auth-form mx-auto my-auto">
          <Card>
            <CardBody>
              {/* Logo */}
                <img
                  className="auth-form__logo d-table mx-auto mb-3"
                  src={require("../images/logoautocorp.png")}
                  alt="Shards Dashboards - Login Template"
                />

              {/* Title */}
              <h5 className="auth-form__title text-center mb-4">
                Cambiar contraseña
              </h5>

              {/* Form Fields */}
              <Form onSubmit={this.onSubmit}>
                <Dialog
                  open={this.state.dialogOpen}
                  fullWidth
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">{"Cambio de contraseña"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                        {this.state.message}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions disableSpacing="false">  
                    <Button href="/login" variant="contained" color="primary" >
                        Aceptar
                    </Button>
                  </DialogActions>
                </Dialog>

                <FormGroup>
                  <label htmlFor="exampleInputPassword1">Contraseña</label>
                  <FormInput
                    type="password"
                    invalid={this.state.error}
                    id="password"
                    name="password"
                    value={this.state.password}
                    onChange={this.onChange}
                    placeholder="Contraseña"
                    autoComplete="new-password"
                  />
                </FormGroup>
                <FormGroup>
                  <label htmlFor="exampleInputPassword2">Repetir contraseña</label>
                  <FormInput
                    type="password"
                    id="repeatPassword"
                    invalid={this.state.error}
                    name="password2"
                    value={this.state.repeatPassword}
                    onChange={this.onChange}
                    placeholder="Repetir contraseña"
                    autoComplete="new-password"
                  />
                </FormGroup>
                {(this.state.error) ? <label style={{color:"red"}}>{this.state.error}</label> :''}

                <Button
                  pill
                  theme="accent"
                  className="d-table mx-auto"
                  type="submit"
                >
                  Cambiar contraseña
                </Button>

              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
    )
  } 
}

export default ResetPassword;
